import * as React from "react";

const LicenseTypeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#000"
      d="M9.375 1.172 17.5 5.234v10.157l-8.125 4.052-8.125-4.052V5.234zm6.104 4.453L9.375 2.578 7.021 3.75l6.065 3.066zM9.375 8.672l2.324-1.152-6.074-3.067-2.354 1.172zM2.5 6.64v7.968l6.25 3.125V9.766zM10 17.734l6.25-3.125V6.641L10 9.766z"
    ></path>
  </svg>
);

export default LicenseTypeIcon;
